import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { allFilterPages } from '@features/filter/static/filterUtil';
import Checkbox from '@features/filter/v2/Checkbox';
import FilterName from '@features/filter/v2/FilterName';

const Market = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setData(allData);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.SAMPLE_LIST]: dependentFilterList?.marketList,
		[allFilterPages.SAMPLE_DETAILS]: dependentFilterList?.marketList,
		[allFilterPages.COSTING_LIST]: dependentFilterList?.marketList,
		[allFilterPages.COSTING_DETAILS]: dependentFilterList?.marketList,
		[allFilterPages.POM_LIST]: dependentFilterList?.marketList,
		[allFilterPages.BLOCK_SUGGESTIONS]: dependentFilterList?.marketList,
		[allFilterPages.BLOCK_LIBRARY_CARD_VIEW_LIST]: dependentFilterList?.marketList,
		[allFilterPages.PRODUCT_LIST]: dependentFilterList?.marketList,
		[allFilterPages.FAVOURITE_DETAILS]: dependentFilterList?.marketList,
		[allFilterPages.MY_ORDER]: dependentFilterList?.marketList,
		[allFilterPages.COLLECTION_DETAILS]: dependentFilterList?.marketList,
		[allFilterPages.TREND_RESEARCH]: dependentFilterList?.marketList
	};

	const onFetchData = async () => {
		let responseData = filterData[filterPageName];
		responseData = responseData?.map((item) => {
			return { id: item.id, name: item.name, count: item?.count };
		});
		setAllData(responseData);
		setData(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allData?.filter((item) => item?.name?.toLowerCase().includes(e.target.value.toLowerCase()))
			: allData;
		setData(searchResult);
	};
	return (
		<>
			<FilterName type="MARKET" />
			<Checkbox data={data} type="MARKET" handleSearch={handleSearch} />
		</>
	);
};

export default Market;
